import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthContextProvider } from "./contexts/auth";
import { SocketContextProvider } from "./contexts/socket";
import { LoaderContextProvider } from "./contexts/loader";

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <LoaderContextProvider>
            <AuthContextProvider>
                <SocketContextProvider>
                    <App />
                </SocketContextProvider>
            </AuthContextProvider>
        </LoaderContextProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
